import { render, staticRenderFns } from "./ModalDoctorNoteAdd.vue?vue&type=template&id=9c2fd00a"
import script from "./ModalDoctorNoteAdd.vue?vue&type=script&lang=js"
export * from "./ModalDoctorNoteAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports